import { Layer } from '@app/modules/cop/store/cop/models';
import { Document, Dataset } from '@app/modules/core/store/models';
import { API_BASE_URL } from '@app/core/constants';
import { StandardFeature } from '../standard/standard.feature';
import { MarkerUrls } from '../feature.model';

export class TrafficCameraFeature extends StandardFeature {
  protected markerStyles: Partial<CSSStyleDeclaration> = {
    transform: 'translateY(10px)'
  };

  protected getAdditionalMarkerData(params: {
    layer: Layer;
    dataset: Dataset;
    document: Document;
    geometry: any;
  }): Record<string, string | number | boolean> {
    const [lng = null, lat = null] = params?.geometry?.coordinates ?? [];
    return {
      isCameraCluster: document['is_camera_cluster'] ?? false,
      cameraName: document['name'],
      position: `${lat}-${lng}`
    };
  }

  buildMarkerImageUrls(layer: Layer, dataset: Dataset, document: Document, cacheBuster: number): MarkerUrls {
    const { status, color } = document.out_of_service ? { status: 'inactive', color: 'C92A2A' } : { status: 'active', color: '40C057' };
    const imageName = `camera-${status}-pin`;

    return {
      normal: `${API_BASE_URL}/v1/meta/markers/${imageName}/${color}/0/0/normal/${imageName}.png`,
      selected: `${API_BASE_URL}/v1/meta/markers/${imageName}/${color}/0/0/selected/${imageName}.png`
    };
  }
}
